export const getTimestampInSeconds = date => Math.floor(date.getTime() / 1000);
